var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/dagre-d3/~/lodash/_Symbol.js
// module id = 255
// module chunks = 0